import {setLoading, useMaterialUIController} from "../../Context/mui";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import {
    Autocomplete,
    ButtonBase,
    Grid,
    Slide,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, TextField
} from "@mui/material";
import {Table} from "reactstrap";
import MDBox from "../../Components/MDBox";
import Paper from "@mui/material/Paper";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import React, {forwardRef, useEffect, useState} from "react";
import {MessageModel} from "../../Api/Model/MessageModel";
import Cookies from "js-cookie";
import {v4 as uuid} from "uuid"
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as DeleteIcon} from '../../Asset/images/icons/deleteicon.svg'
import {ReactComponent as Moshahede} from '../../Asset/images/icons/lets-icons_view.svg'
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDDate from "../../Components/MDDate";
import MDButton from "../../Components/MDButton";
import {ErrorToaast, InfoToaast} from "../../utils/toast/Toast";
import MDSelect from "../../Components/MDSelect";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {CurrentUser} from "../../utils/Hooks/currentUser";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const initalSearchParams = {
    Username: "",
    Role: "",
    AzSabt: "",
    TaSabt: "",
    Vaziat: ""
};
export default function FroumPage() {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [searchParams, setSearchParams] = useState(initalSearchParams);
    const [sendmsgdialog, setSendmsgdialog] = useState({open: false, id: 0});
    const [msgdialog, setMsgdialog] = useState({open: false, msg: null});
    const [searchList, setSearchList] = useState([]);
    const [pplvalue, setPplValue] = React.useState();
    const [onvanmsg, setOnvanMsg] = React.useState("");
    const [textMsg, setTextMsg] = React.useState("");
    const [inputPplValue, setInputPplValue] = React.useState('');

    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    const [controller, dispatch] = useMaterialUIController();
    const {loading} = controller;
    let Api = new MessageModel(Cookies.get("cst") ?? "");

    useEffect(() => {
        setLoading(dispatch, true);
        Api
            .getAllWithPaginate(pageNumber, pageSize)
            .then((r) => {
                setRows(r.data.data);
            })
            .then(x => {
                Api.GetAllMsgPeople().then((r) => {
                    setSearchList(r.data.data);
                })
            }).catch
            (r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);

    function handleSearch() {
        const {Username, Role, AzSabt, TaSabt, Vaziat} = searchParams;
        if (
            Username === "" &&
            Role === "" &&
            AzSabt === "" &&
            Vaziat === "" &&
            TaSabt === ""
        ) {
            return setCounter((c) => c + 1);
        } else {
            setLoading(dispatch, true);
            Api
                .GetSearch(
                    searchParams.Username,
                    searchParams.Role,
                    searchParams.AzSabt,
                    searchParams.TaSabt,
                    searchParams.Vaziat,
                )
                .then((r) => {
                    setRows({content: r.data.data, pageSize: 0, totalPages: 0});
                    setLoading(dispatch, false);
                })
                .catch((r) => {
                    setLoading(dispatch, false);
                    ErrorToaast("دریافت اطلاعات با مشکل مواجه شد");
                });
        }

    }

    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        setPageSize(+event.target.value);
        setPageNumber(1);
    };

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    function sendNewMsg() {
        setSendmsgdialog({id: 0, open: true})
    }

    const handleSendMessage = () => {
        if (onvanmsg === "" || textMsg === "" || pplvalue === 0) {
            ErrorToaast("لطفا مقادیر را پر کنید")
            return;
        }
        Api
            .SendMessage({
                Text: textMsg,
                Title: onvanmsg,
                ReceiveId: pplvalue?.id
            })
            .then((r) => {
                setSendmsgdialog({id: 0, open: false})

                InfoToaast("پیام با موفقیت ارسال شد")
                setCounter(r => r + 1);
            })
            .finally(() => {
                setLoading(dispatch, false);
            });

    };
    const handleCloseMsg = () => {
        setOnvanMsg("")
        setTextMsg("")
        setPplValue("")
        setSendmsgdialog({id: 0, open: false})
    };

    function handleClickOpen(msg) {
        Api
            .ToggleRead(msg.id)
            .then((r) => {
                setMsgdialog({msg, open: true})
                setCounter(r => r + 1);
            })
            .catch(() => {
                ErrorToaast("خطا در دریافت اطلاعات")
            });
    }

    function handleCloseShowMsg() {
        setMsgdialog({msg: null, open: false})

    }

    return <DashboardLayout>

        <DashboardNavbar name={"تالار گفتگو"}>
            تالار گفتگو
        </DashboardNavbar>
        <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
            <MDTypography fontSize={14}>جستجو در فرم ها</MDTypography>
            <Grid
                container
                mb={2}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            >
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>نام کاربری</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDInput
                            size={"small"}
                            name="Username"
                            label={"نام کاربری"}
                            fullWidth
                            onChange={(e) =>
                                setSearchParams((p) => ({...p, Username: e.target.value}))
                            }
                            value={searchParams.Username}
                            focused
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>وضعیت</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDSelect
                            id="Vaziat"
                            name="Vaziat"
                            onChange={(r) => {
                                setSearchParams((p) => ({
                                    ...p,
                                    Vaziat: r,
                                }))
                            }}


                            value={searchParams.Vaziat}

                            disabled={loading}
                            w={{xs: "100%", md: "100%", lg: "100%",}}
                            label={"وضعیت"}>
                            <option value={0}>همه</option>
                            <option value={1}>فرستنده</option>
                            <option value={2}>گیرنده</option>


                        </MDSelect>

                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>{"نقش"}</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDInput
                            size={"small"}
                            name="Role"
                            label={"نقش"}
                            fullWidth
                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    Role: e.target.value,
                                }))
                            }
                            value={searchParams.Role}
                            focused
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>

                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>از تاریخ</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDDate
                            name="FormDate"

                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    AzSabt: e,
                                }))
                            }
                            defaultValue={searchParams.AzSabt}
                            label={"تاریخ "}
                            sx={{width: "100%"}}
                            portal
                            fullWidth
                            disabled={loading}
                        />

                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>تا تاریخ</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDDate
                            name="FormDate"

                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    TaSabt: e,
                                }))
                            }
                            defaultValue={searchParams.TaSabt}
                            label={"تاریخ "}
                            sx={{width: "100%"}}
                            portal
                            fullWidth
                            disabled={loading}
                        />

                    </Grid>
                </Grid>
            </Grid>
            <MDBox>
                <MDButton variant="text" color="primary" onClick={handleSearch}>
                    {"جستجو"}
                </MDButton>
                <MDButton
                    variant="text"
                    color="secondary"
                    onClick={() => {
                        setSearchParams(initalSearchParams);
                        setCounter((c) => c + 1);
                    }}
                >
                    {"انصراف"}
                </MDButton>
            </MDBox>
        </MDBox>
        <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
            <MDButton size={"large"} variant={"contained"} sx={{background:"#0E2A4F", }} color={"dark"} onClick={() => sendNewMsg()}>
                ارسال پیام جدید
            </MDButton>
        </MDBox>
        <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
            <Grid container flexDirection={"column"}>
                <Grid item sx={{width: "100%"}}>
                    <TableContainer component={Paper} sx={{width: "100%"}}>
                        <Table sx={{minWidth: 700}} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        نام کاربری
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        وضعیت
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        مشاهده
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        تاریخ
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        نقش
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        عنوان پیام
                                    </MDTableCell>
                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                        عملیات
                                    </MDTableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows?.content.length < 1 && (
                                    <MDTableRow
                                        sx={{
                                            "&:last-child td, &:last-child th": {border: 0},
                                        }}
                                    >
                                        <MDTableCell colSpan={9} align="right">
                                            بدون اطلاعات
                                        </MDTableCell>
                                    </MDTableRow>
                                )}
                                {rows?.content?.map((r) => {
                                    return (
                                        <MDTableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={uuid()}
                                        >
                                            <MDTableCell align={"center"}>
                                                {r?.userUserName}
                                            </MDTableCell>
                                            <MDTableCell align={"center"}>
                                                {r?.vaziat}
                                            </MDTableCell>
                                            <MDTableCell align={"center"}>
                                                {r?.isRead ? "خوانده شده" : "خوانده نشده"}
                                            </MDTableCell>
                                            <MDTableCell align={"center"}>
                                                {new Date(r?.created).toLocaleString('fa-IR')}
                                            </MDTableCell>
                                            <MDTableCell align={"center"}>
                                                {r?.role ==="Student"&& "دانش آموز"}
                                                {r?.role ==="Pezeshk"&& "پزشک"}
                                                {r?.role ==="Morabi"&& "مربی"}
                                                {r?.role ==="Parent"&& "والدین"}
                                            </MDTableCell>
                                            <MDTableCell align={"center"}>
                                                {r?.title}
                                            </MDTableCell>
                                       

                                            <MDTableCell align={"center"}>
                                                <Tooltip title="مشاهده">
                                                    <IconButton onClick={() => handleClickOpen(r)}>
                                                        <Moshahede/>
                                                    </IconButton>
                                                </Tooltip>
                         
                                            </MDTableCell>
                                            
                                        </MDTableRow>


                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {rows?.content.length > 0 && (
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={rows.totalPages}
                            rowsPerPage={pageSize}
                            page={pageNumber - 1}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelDisplayedRows={defaultLabelDisplayedRows}
                            labelRowsPerPage={<>تعداد در هر صفحه</>}
                        />
                    )}
                </Grid>
            </Grid>

        </MDBox>
        <Dialog
            open={sendmsgdialog.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseMsg}
            fullWidth
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>ارسال پیام</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>
                    <Grid container gap={5}>
                        <Grid item container gap={2}>
                            <MDTypography>
                                ارسال از طرف
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                 {CurrentUser()?.user.UserName}
                            </MDTypography>
                        </Grid>
                        <Grid item container gap={2} flex={1}>
                            <MDTypography>
                                نام کاربری گیرنده
                            </MDTypography>
                            {/*<div>*/}

                            <Autocomplete
                                value={pplvalue}
                                onChange={(event, newValue) => {
                                    setPplValue(newValue);
                                }}
                                inputValue={inputPplValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputPplValue(newInputValue);
                                }}
                                id="controllable-states-demo"
                                options={searchList}
                                fullWidth
                                renderInput={(params) => <TextField fullWidth sx={{width: "100%"}} {...params}  />}
                                // renderInput={(params) => <MDInput {...params} label="Controllable"/>}
                            />
                            {/*</div>*/}

                        </Grid>
                        <Grid container item>
                            <MDInput
                                id="onvanmsg"
                                name="onvanmsg"
                                value={onvanmsg}
                                onChange={(r) => setOnvanMsg(r.target.value)}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%"}}
                                fullWidth
                                label={"عنوان گفتگو"}/>

                        </Grid>
                        <Grid container item>
                            <MDInput
                                id="textMsg"
                                name="textMsg"
                                multiline
                                rows={4}
                                value={textMsg}
                                onChange={(r) => setTextMsg(r.target.value)}
                                // error={
                                //     Boolean(formik.errors.Varzesh)
                                // }
                                // helperText={formik.errors.Varzesh}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%"}}
                                fullWidth
                                label={"متن     "}/>

                        </Grid>
                    </Grid>

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={"outlined"} color={"warning"} size={"large"}
                          onClick={handleSendMessage}>ارسال</MDButton>
                <MDButton variant={"outlined"} color={"info"} size={"large"} onClick={handleCloseMsg}>بازگشت</MDButton>
            </DialogActions>
        </Dialog>
        <Dialog
            open={msgdialog.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseShowMsg}
            fullWidth
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>مشاهده پیام</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>
                    <Grid container gap={1}>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}>

                            <MDTypography>
                                ارسال از طرف
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.userUserName}
                            </MDTypography>

                        </Grid>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}>
                            <MDTypography>
                                عنوان
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.title}
                            </MDTypography>
                        </Grid>
                        <Grid container item gap={2} border={"1px solid #2e0b83"} px={1} py={1} borderRadius={2}
                              minHeight={"200px"}>
                            <MDTypography>
                                متن
                            </MDTypography>
                            <MDTypography fontWeight={"bold"}>
                                {msgdialog.msg?.text}
                            </MDTypography>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={"outlined"} color={"info"} size={"large"}
                          onClick={handleCloseShowMsg}>بازگشت</MDButton>
            </DialogActions>
        </Dialog>
    </DashboardLayout>


}


